<template>
  <!-- Isabel wants to hide all of this -->
  <div
    v-if="item && loggedUser.roles.includes('super-admin') && false"
    class="col-6"
  >
    <div class="researcher__now">
      <h5>
        <span class="badge bg-warning me-1">NOW</span>
        <a :href="url ? $router.resolve({name: url, params: {id: item.activity_id}}).href : ''">
          <strong>{{ item.title }}:</strong>
          <span class="text-dark">{{ item.description }} {{ item.begin_date }} - {{ item.end_date }}</span>
        </a>
      </h5>
      <p
        v-if="item.trips && item.trips[0]"
        class="mb-0"
      >
        <small>in {{ item.trips[0].complete_address }} ({{ item.trips[0].country }}), from {{ item.trips[0].start_date }} to {{ item.trips[0].end_date }}</small>
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      item: null,
      loading: false,
      url: '',
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'auth/admin',
      user: 'users/user',
    }),
  },
  async mounted() {
    Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/is-out/${this.user.id}`).then(resp => {
      this.item = resp.data
      this.getUrl()
    })
  },
  methods: {
    getUrl() {
      if (this.item && this.item.type) {
        switch (this.item.type) {
          case 1:
            this.url = 'researcher.conferences.index'
            break
          case 2:
            this.url = 'researcher.phds.index'
            break
          case 3:
            this.url = 'researcher.courses.index'
            break
          case 4:
            this.url = 'researcher.managerial.index'
            break
          case 5:
            this.url = 'researcher.stays-research.index'
            break
          case 6:
            this.url = 'researcher.disseminations.index'
            break
          default:
            this.url = 'researcher.activities.index'
        }
      }
    },
  },
}
</script>
